import { FormControlLabel } from '@packages/fenrir/components/form-control-label';
import { Switch } from '@packages/fenrir/components/switch';

import type { FeatureFlagKey } from '../feature-flags';
import { useFeatureFlags } from '../FeatureFlags';
import { useFeatureFlag } from '../use-feature-flag';

type FeatureFlagControlProps = {
  flag: FeatureFlagKey;
};

export const FeatureFlagControl = ({ flag }: FeatureFlagControlProps) => {
  const [flagState, setFlagState] = useFeatureFlag(flag);
  const { toggleFlag, featureFlags } = useFeatureFlags();

  const handleChange = (value: boolean) => {
    setFlagState(value);
    toggleFlag(flag, value);
  };

  return (
    <FormControlLabel
      control={
        <Switch
          checked={flagState || featureFlags[flag]}
          onChange={(e) => handleChange(e.target.checked)}
          name={flag}
        />
      }
      label={flag}
    />
  );
};
